/*******************************************************************************
 * Controller: itemsController
 *
 * Controller for the items view.
 *******************************************************************************/
/* @ngInject */ export function ItemsController(
  $scope,
  AddChangeItemDialog,
  AddChangeItemOptionMasterDialog,
  Alert,
  BooksSvc,
  BusyScreen,
  GenerateBarcodeSheetDialog,
  ItemAdminService,
  ItemAdminGridStates,
  ItemTypes,
  PrintItemListDialog,
  SelectItemTypeDialog,
  uiGridConstants
) {
  /*----------------------*/
  /* Item report options. */
  /*----------------------*/
  /** Barcode Sheet. */ var mRObarcodes = { label: 'Barcode Sheet' };
  /** Inventory Worksheet. */ var mROInventory = {
    label: 'Inventory Worksheet'
  };
  /** Item List. */ var mROItemList = { label: 'Item List' };

  /** Report Options List.  */ $scope.dpReportOptions = [
    mRObarcodes,
    mROInventory,
    mROItemList
  ];
  /** Default Report Option */ $scope.activeReportOption =
    $scope.dpReportOptions[0];

  /*----------------------------*/
  /* Items grid filter options. */
  /*----------------------------*/
  var mTypeFilter = { type: uiGridConstants.filter.SELECT };
  var mCategoryFilter = { type: uiGridConstants.filter.SELECT };

  /*----------------------*/
  /* Dialog active flags. */
  /*----------------------*/
  var mSelectItemTypeDialogActive = false;
  var mAddChangeItemDialogActive = false;
  var mGenerateBarcodeDialogActive = false;
  var mPrintItemListDialogActive = false;

  /*----------------------------------------------*/
  /* Template for the Actions column in the grid. */
  /*----------------------------------------------*/
  var actionsTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    '<table><tr>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change Item" ng-click="grid.appScope.changeItem(row.entity)"></span></td>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-trash csm-grid-space-target" title="Delete Item" ng-click="grid.appScope.deleteItem(row.entity)"></span></td>' +
    '</tr></table>' +
    '</div>';

  /*---------------------------------*/
  /* Template to add double click    */
  /* functionality to each grid row. */
  /*---------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.changeItem(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*-------------------*/
  /* Item grid options */
  /*-------------------*/
  $scope.itemsGrid = {
    enableColumnMenus: false,
    enableFiltering: true,
    enableColumnResizing: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableRowSelection: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: true,
    saveSort: true,
    rowTemplate: dblClickTemplate,
    onRegisterApi: function (gridApi) {
      $scope.itemsGrid.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        field: 'type',
        width: '16%',
        minWidth: 210,
        labelFunction: getTypeName,
        cellClass: getInactiveCellClass,
        filter: mTypeFilter
      },
      {
        field: 'category',
        cellClass: getInactiveCellClass,
        width: '16%',
        minWidth: 180,
        filter: mCategoryFilter
      },
      {
        field: 'shortDescription',
        displayName: 'Item Name',
        minWidth: 180,
        cellClass: getInactiveCellClass
      },
      {
        field: 'sku',
        width: '16%',
        minWidth: 115,
        displayName: 'SKU',
        cellClass: getInactiveCellClass
      },
      {
        field: 'amount',
        width: '10%',
        minWidth: 115,
        displayName: 'Price',
        cellClass: getInactiveCellClass,
        /*------------------------------------------------------*/
        /* Hide amounts for records & donations. CellTemplate & */
        /* cellFilter will not work together, so the currency   */
        /* filter will need to be in the cell template.         */
        /*------------------------------------------------------*/
        cellTemplate:
          '<div class="ui-grid-cell-contents">{{ (grid.appScope.isDonation(row.entity) || grid.appScope.isRecord(row.entity) ? NaN : row.entity.amount) | currency }}</div>'
      },
      {
        field: 'active',
        width: '10%',
        minWidth: 80,
        displayName: 'Active?',
        cellFilter: 'boolToString',
        cellClass: getInactiveCellClass,
        filter: {
          term: true,
          type: uiGridConstants.filter.SELECT,
          selectOptions: [
            { value: '', label: 'ALL' },
            { value: true, label: 'Y' },
            { value: false, label: 'N' }
          ]
        }
      },
      {
        appScope: $scope,
        cellTemplate: actionsTemplate,
        displayName: 'Actions',
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        pinnedRight: true,
        minWidth: 75,
        width: 75
      }
    ]
  };

  /*****************************************************************************
   * addItem */
  /**
   * Add a new item type. Displays a dialog to select item type then passes the
   * selected type ID to the AddChangeItemDialog to create a new item.
   *****************************************************************************/
  $scope.addItem = function () {
    /*----------------------------------------*/
    /* Exit if the dialog is already active. */
    /*----------------------------------------*/
    if (mSelectItemTypeDialogActive) return;

    /*-------------------------------------*/
    /* Allow the user to select item type  */
    /* the created a new item of the type. */
    /*-------------------------------------*/
    mSelectItemTypeDialogActive = true;
    SelectItemTypeDialog.show()
      .then(function (resp) {
        AddChangeItemDialog.show(
          0,
          resp,
          $scope.anonDefaultValue,
          $scope.hideIncidental,
          $scope.hideOptionQtyChange
        ).then(function () {
          /*------------------------------*/
          /* Reload list and update grid. */
          /*------------------------------*/
          ItemAdminService.reloadItems().then(function () {
            $scope.itemsGrid.data = ItemAdminService.getItems();
          });
        });
      })
      .finally(function () {
        mSelectItemTypeDialogActive = false;
      });
  };

  /*****************************************************************************
   * changeItem */
  /**
   * Modifies an existing item.
   *
   * @param   item   Item to modify.
   *****************************************************************************/
  $scope.changeItem = function (item) {
    /*--------------------------*/
    /* Nothing to modify, exit. */
    /*--------------------------*/
    if (!item) {
      Alert.error('Choose an item to modify');
      return;
    }

    /*---------------------------------*/
    /* Dialog is already active, exit. */
    /*---------------------------------*/
    if (mAddChangeItemDialogActive) return;

    /*------------------------*/
    /* Modify user selection. */
    /*------------------------*/
    mAddChangeItemDialogActive = true;
    AddChangeItemDialog.show(
      item.id,
      item.type,
      $scope.anonDefaultValue,
      $scope.hideIncidental,
      $scope.hideOptionQtyChange
    )
      .then(function (item) {
        /*------------------------------*/
        /* Reload list and update grid. */
        /*------------------------------*/
        ItemAdminService.reloadItems().then(function () {
          $scope.itemsGrid.data = ItemAdminService.getItems();
        });
      })
      .finally(function () {
        mAddChangeItemDialogActive = false;
      });
  };

  /*****************************************************************************
   * deleteItem */
  /**
   * Delete the provided item and reload the grid.
   *
   * @param   item    Item to remove.
   *****************************************************************************/
  $scope.deleteItem = function (item) {
    /*-----------------------------------------*/
    /* Nothing to delete, alert user and exit. */
    /*-----------------------------------------*/
    if (!item) {
      Alert.error('Select an item to remove.');
      return;
    }

    /*-------------------------------------*/
    /* Confirm with user for item removal. */
    /*-------------------------------------*/
    Alert.confirm(
      'This action cannot be undone. Are you sure you want to remove Item: {0}?'.format(
        item.shortDescription
      )
    ).then(function () {
      /*------------------*/
      /* Remove the item. */
      /*------------------*/
      BusyScreen.setBusy(true);
      ItemAdminService.dropItem(item.type, item.id)
        .then(
          function () {
            /*--------------------------------------------------------*/
            /* Display success and load updated itemOptionMasterList. */
            /*--------------------------------------------------------*/
            Alert.success('Item sucessfully removed.');
            ItemAdminService.reloadItems().then(function () {
              $scope.itemsGrid.data = ItemAdminService.getItems();
            });
          },
          /*---------------------------------------------*/
          /* Server responded with an error, alert user. */
          /*---------------------------------------------*/
          function (resp) {
            Alert.error(
              resp.parsedResponse.message() || 'Error deleting this item',
              'Failed to remove item.'
            );
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    });
  };

  /*****************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive or empty string.
   *****************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive' : '';
  }

  /*****************************************************************************
   * getTypeName */
  /**
   * Label function that takes an item and returns the corresponding item type
   * name from the ITEM_TYPES array.
   *
   * @param   item    Item
   * @return  String  Item type to display in the grid Type column.
   *****************************************************************************/
  function getTypeName(item) {
    var types = (ItemTypes || []).filter(function (e) {
      return e.value == item.type;
    });
    return (
      types[0].label + ($scope.isInvProduct(item) ? ' (Inventory Tracked)' : '')
    );
  }

  /*****************************************************************************
   * handlePrint */
  /**
   * Handles the print click to generate a report with the current active report
   * option.
   *
   * @param  sender  Selected report option
   *****************************************************************************/
  $scope.handlePrint = function () {
    /*----------------------*/
    /* Print Item requested */
    /*----------------------*/
    if ($scope.activeReportOption == mROItemList) {
      /*-------------------------*/
      /* Dialog is active, exit. */
      /*-------------------------*/
      if (mPrintItemListDialogActive) return;

      /*------------------------------------------*/
      /* Prepend default option to category list. */
      /*------------------------------------------*/
      var categories = [{ id: 0, category: 'All Categories' }].concat(
        ItemAdminService.getCategories()
      );

      /*---------------------------*/
      /* Display the print dialog. */
      /*---------------------------*/
      mPrintItemListDialogActive = true;
      PrintItemListDialog.show(categories)
        .then()
        .finally(function () {
          mPrintItemListDialogActive = false;
        });
    } else if ($scope.activeReportOption == mRObarcodes) {
      /*-------------------------*/
      /* Barcode Sheet requested */
      /*-------------------------*/
      /*-------------------------*/
      /* Dialog is active, exit. */
      /*-------------------------*/
      if (mGenerateBarcodeDialogActive) return;

      mGenerateBarcodeDialogActive = true;
      GenerateBarcodeSheetDialog.show()
        .then()
        .finally(function () {
          mGenerateBarcodeDialogActive = false;
        });
    } else if ($scope.activeReportOption == mROInventory)
      /*-------------------------------*/
      /* Inventory worksheet requested */
      /*-------------------------------*/
      window.open('PrintInventoryWSPDF.aspx?rt=PDF');
  };

  /*****************************************************************************
   * init */
  /**
   * Populate the grid, set the visibility of the SKU column and set up column
   * filters.
   *****************************************************************************/
  function init() {
    /*----------------------------------------*/
    /* Link the state data and ready the grid */
    /*----------------------------------------*/
    ItemAdminGridStates.items.init($scope.itemsGrid);

    $scope.itemsGrid.data = ItemAdminService.getItems();
    $scope.itemsGrid.columnDefs[3].visible = !$scope.hideItemSku;

    /*------------------------------------------------------*/
    /* Build the Type and Category column dropdown filters. */
    /*------------------------------------------------------*/
    var items = ItemAdminService.getItems();

    var categorySelectOptions = [];
    var itemSelectOptions = [];

    /*-----------------------------------------------*/
    /* Traverse the items list and uniquely add the  */
    /* category and type labels to the options list. */
    /*-----------------------------------------------*/
    items.forEach(function (item) {
      if (categorySelectOptions.indexOf(item.category) < 0)
        categorySelectOptions.push(item.category);

      /*-------------------------------------------------------------*/
      /* For inventory tracked products, set the label up correctly. */
      /*-------------------------------------------------------------*/
      var itemLabel = getTypeName(item);

      if (itemSelectOptions.indexOf(itemLabel) < 0)
        itemSelectOptions.push(itemLabel);
    });

    /*----------------------------------*/
    /* Sort and map the select options. */
    /*----------------------------------*/
    categorySelectOptions = categorySelectOptions
      .sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      })
      .map(function (name) {
        return { value: name, label: name };
      });

    itemSelectOptions = itemSelectOptions
      .sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      })
      .map(function (name) {
        return { value: name, label: name };
      });

    mCategoryFilter.selectOptions = categorySelectOptions;
    mTypeFilter.selectOptions = itemSelectOptions;

    /*-------------------------------------------------------------*/
    /* Force strict matching on the type or else partial matching  */
    /* will cause Product (Inventory Tracked)" to match "Product". */
    /*-------------------------------------------------------------*/
    mTypeFilter.condition = uiGridConstants.filter.EXACT;

    /*-----------------------------------*/
    /* Ignore trailing whitespace when   */
    /* matching user created categories. */
    /*-----------------------------------*/
    mCategoryFilter.condition = function (searchTerm, cellValue) {
      return cellValue.trim() == searchTerm.trim();
    };

    /*------------------------------------*/
    /* Force the raw unescaped term to    */
    /* be passed to the filter condition. */
    /*------------------------------------*/
    mCategoryFilter.rawTerm = true;
  }

  /*****************************************************************************
   * onReportOption */
  /**
   * Report selection handler. Updates the active report type with the user's
   * selection so it is visible on the button and generates a report of the active
   * type.
   *
   * @param  reportOption  Selected report option
   *****************************************************************************/
  $scope.onReportOption = function (reportOption) {
    $scope.activeReportOption = reportOption;
    $scope.handlePrint();
  };

  /*-------------*/
  /* View setup. */
  /*-------------*/
  init();
}
